import { wordingType } from '@Types/wording_type'
const wording: wordingType = {
  app_name: 'CMS',
  favicon: 'favicon.ico',
  topic: 'Topic',
  subtopic: 'Sub-Topic',
  category: 'Sub-Topic',
  channel: 'Channel',
  content_page: {
    abstract: 'ประเภทเนื้อหา',
    summary: 'เนื้อหาอย่างย่อ',
  },
}
export default wording
